import instance from '../scorpiusInstance';
import {
  DELETE_APP_ROLE_START,
  DELETE_APP_ROLE_SUCCESS,
  DELETE_APP_ROLE_ERROR,
} from '../types';

export const deleteAppRoleStart = (orgId, appName) => ({
  type: DELETE_APP_ROLE_START,
  orgId,
  appName,
});

export const deleteAppRoleSuccess = (orgId, appName, role) => ({
  type: DELETE_APP_ROLE_SUCCESS,
  orgId,
  appName,
  role,
});

export const deleteAppRoleError = (orgId, appName, role, error) => ({
  type: DELETE_APP_ROLE_ERROR,
  orgId,
  appName,
  role,
  error,
});

/**
 * Deletes the role for the given organization's app.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} role
 * @param {String} role.id
 */
export const deleteAppRole = (orgId, appName, role) => async dispatch => {
  dispatch(deleteAppRoleStart(orgId, appName));
  try {
    await instance.delete(
      `/organizations/${orgId}/${appName}/roles/${role.id}`,
      { headers: { retry: true } },
    );
    return dispatch(deleteAppRoleSuccess(orgId, appName, role));
  } catch (error) {
    throw dispatch(deleteAppRoleError(orgId, appName, role, error));
  }
};

export default deleteAppRole;
